function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { languageFromLocale } from "./locale.mjs";
var LETTERS = new Map([['a', 'α'], ['b', 'ḅ'], ['c', 'ͼ'], ['d', 'ḍ'], ['e', 'ḛ'], ['f', 'ϝ'], ['g', 'ḡ'], ['h', 'ḥ'], ['i', 'ḭ'], ['j', 'ĵ'], ['k', 'ḳ'], ['l', 'ḽ'], ['m', 'ṃ'], ['n', 'ṇ'], ['o', 'ṓ'], ['p', 'ṗ'], ['q', 'ʠ'], ['r', 'ṛ'], ['s', 'ṡ'], ['t', 'ṭ'], ['u', 'ṵ'], ['v', 'ṽ'], ['w', 'ẁ'], ['x', 'ẋ'], ['y', 'ẏ'], ['z', 'ẓ'], ['A', 'Ḁ'], ['B', 'Ḃ'], ['C', 'Ḉ'], ['D', 'Ḍ'], ['E', 'Ḛ'], ['F', 'Ḟ'], ['G', 'Ḡ'], ['H', 'Ḥ'], ['I', 'Ḭ'], ['J', 'Ĵ'], ['K', 'Ḱ'], ['L', 'Ḻ'], ['M', 'Ṁ'], ['N', 'Ṅ'], ['O', 'Ṏ'], ['P', 'Ṕ'], ['Q', 'Ǫ'], ['R', 'Ṛ'], ['S', 'Ṣ'], ['T', 'Ṫ'], ['U', 'Ṳ'], ['V', 'Ṿ'], ['W', 'Ŵ'], ['X', 'Ẋ'], ['Y', 'Ŷ'], ['Z', 'Ż']]);
var DEFAULT_RATIO = 1.15;
var LOCALE_RATIOS = new Map([['zh', 0.5], ['ja', 0.5], ['ko', 0.8], ['fr', 1.3], ['it', 1.3], ['de', 1.5], ['nl', 1.5]]);
export function sizeRatio(_ref) {
  var locale = _ref.to;
  if (locale == null) {
    return DEFAULT_RATIO;
  }
  return LOCALE_RATIOS.get(locale) || LOCALE_RATIOS.get(languageFromLocale(locale)) || DEFAULT_RATIO;
}
export function pseudotranslate(string) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    delimiter = _ref2.delimiter,
    _ref2$startDelimiter = _ref2.startDelimiter,
    startDelimiter = _ref2$startDelimiter === void 0 ? delimiter : _ref2$startDelimiter,
    _ref2$endDelimiter = _ref2.endDelimiter,
    endDelimiter = _ref2$endDelimiter === void 0 ? delimiter : _ref2$endDelimiter,
    prepend = _ref2.prepend,
    append = _ref2.append,
    toLocale = _ref2.toLocale;
  var parts = createParts(string, {
    startDelimiter: startDelimiter,
    endDelimiter: endDelimiter
  });
  var adjustableCharacters = parts.reduce(function (sum, part) {
    return typeof part === 'string' ? sum + countAdjustableCharacters(part) : sum;
  }, 0);
  var charactersToAdjust = Math.ceil(adjustableCharacters * sizeRatio({
    to: toLocale
  })) - adjustableCharacters;
  var adjustEvery = adjustableCharacters / Math.abs(charactersToAdjust);
  var adjustAt = adjustEvery;
  var adjustableCharacterIndex = -1;
  var pseudotranslated = parts.reduce(function (pseudotranslated, part) {
    var pseudotranslatedPart = typeof part === 'string' ? _toConsumableArray(part).map(function (character) {
      var isAdjustable = isAdjustableCharacter(character);
      if (isAdjustable) {
        adjustableCharacterIndex++;
      }
      var newCharacter = LETTERS.get(character) || character;
      var shouldAdjust = isAdjustable && adjustableCharacterIndex + 1 === Math.floor(adjustAt);
      if (shouldAdjust) {
        adjustAt += adjustEvery;
        return charactersToAdjust < 0 ? '' : newCharacter.repeat(2);
      } else {
        return newCharacter;
      }
    }).join('') : part[0];
    return pseudotranslated + pseudotranslatedPart;
  }, '');
  return "".concat(prepend || '').concat(pseudotranslated).concat(append || '');
}
function isAdjustableCharacter(character) {
  return LETTERS.has(character);
}
function countAdjustableCharacters(string) {
  return _toConsumableArray(string).filter(isAdjustableCharacter).length;
}
function createParts(string, _ref3) {
  var startDelimiter = _ref3.startDelimiter,
    endDelimiter = _ref3.endDelimiter;
  var delimiterRegex = startDelimiter && endDelimiter ? createDelimiterRegex(startDelimiter, endDelimiter) : undefined;
  var lastTokenEndIndex = 0;
  var parts = [];
  if (delimiterRegex) {
    var token = delimiterRegex.exec(string);
    while (token) {
      parts.push(string.substring(lastTokenEndIndex, token.index));
      parts.push(token);
      lastTokenEndIndex = token.index + token[0].length;
      token = delimiterRegex.exec(string);
    }
    parts.push(string.substring(lastTokenEndIndex, string.length));
  } else {
    parts.push(string);
  }
  return parts;
}
function createDelimiterRegex(startDelimiter, endDelimiter) {
  if (startDelimiter.length === 1 && endDelimiter.length === 1) {
    return new RegExp("\\".concat(startDelimiter, "[^\\").concat(endDelimiter, "]*\\").concat(endDelimiter), 'g');
  }
  var escapedStart = _toConsumableArray(startDelimiter).map(function (character) {
    return "\\".concat(character);
  }).join('');
  var escapedEnd = _toConsumableArray(endDelimiter).map(function (character) {
    return "\\".concat(character);
  }).join('');
  return new RegExp("".concat(escapedStart, ".*?").concat(escapedEnd), 'g');
}